// extracted by mini-css-extract-plugin
export default {"fs":"_3a597c91f6 _0ce695bcbe"};